export enum Content {
  ARTICLES = 'Articles',
  TIPS = 'Tips',
}
